// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'map-solid';

export const Component = () => (
  <path d='M9.855 24.516V2.676L15.745 1v21.84l-5.89 1.676ZM2 2.772v18.822c0 .766.383 1.245 1.102 1.389l5.746 1.533V2.676l-4.98-1.292c-.096-.048-.24-.048-.383-.048a1.58 1.58 0 0 0-1.054.383A1.408 1.408 0 0 0 2 2.773v-.001Zm20.498-.24L16.703 1v21.84l5.029 1.34c.048.047.191.047.383.047a1.41 1.41 0 0 0 1.054-.43c.287-.288.431-.624.431-1.055V3.968c0-.719-.383-1.198-1.102-1.437v.002Z' />
);

export const viewBox = '0 0 25 25';
